<mat-toolbar class="toolbar top element-shadow">
  <img alt="broken" src="assets/vectors/logo.svg">
</mat-toolbar>

<iframe style="width: 100%; height: 100%; border: none" [src]="url" allow="geolocation; clipboard-read; clipboard-write *"></iframe>
